import React, { Component } from "react";
import { addMonths } from "date-fns";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classnames from "classnames";

// services
import api from "services/api";

// redux
import {
  Creators as StoresActions,
  Selectors as StoresSelectors,
} from "store/ducks/stores";

// components
import { Form } from "components";

// styles
import "./styles.scss";
class Filters extends Component {
  state = {
    topics: [],
  };

  async componentDidMount() {
    try {
      const response = await api.get("/store/v2/kafka/topics");
      const { data: topics } = response.data;

      this.setState({
        topics: topics
          .filter((topic) => topic.attributes.active)
          .map((topic) => ({
            value: topic.id,
            label: topic.attributes.name,
          })),
      });
    } catch (err) {}
  }

  render() {
    const { topics } = this.state;
    const { data, onChange, onClean, onSubmit } = this.props;

    const maxDate = addMonths(data.date_start, 1);
    const statusOptions = [
      {
          "value": "pending",
          "label": "Pendente"
      },
      {
          "value": "processing",
          "label": "Processando"
      },
      {
          "value": "processed",
          "label": "Processado"
      },
      {
        "value": "failed",
        "label": "Falhou"
      }
  ]
    return (
      <Form className="row form-filters">
        <div className="row">
        <Form.Field className="col-md-3 col-sm-4">
          <Form.Label>Tópico</Form.Label>
          <Form.Select
            placeholder="Tipo"
            value={data.topic}
            options={topics}
            onChange={(value) => onChange("topic", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label className="search-label">Buscar por CPF</Form.Label>
          <Form.Input
            className={classnames("search-input", {
              disable_input:
                data.topic === null ||
                (data.topic.label !== "Lealdade" &&
                  data.topic.label !== "LealdadeConfluent"),
            })}
            name="query"
            value={data.query}
            onChange={(event) => onChange("query", event.target.value)}
          />
          <div className="icon-search">
            <i className="fa fa-search" />
          </div>
        </Form.Field>

        <Form.Field className="col-md-3 col-sm-4">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_start}
              onChange={async (value) => {
                await onChange("date_start", value);
                onChange("date_end", null);
              }}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-3 col-sm-4">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_end}
              onChange={(value) => onChange("date_end", value)}
              minDate={data.date_start}
              maxDate={maxDate}
              disabled={data.date_start === null}
            />
          </Form.Icon>
        </Form.Field>
        </div>

        <Form.Field className="col-md-4 col-sm-4 row form-filters">
          <Form.Label>Status Mensagem</Form.Label>
          <Form.Select
            isMulti
            placeholder="Status"
            value={data.status}
            options={statusOptions}
            onChange={(value) => onChange("status", value)}
          />
        </Form.Field>
        
        <div>     
        <Form.Field className="col-md-3 col-sm-4">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
          <Form.Button
            className="button-apply-filter"
            type="buton"
            onClick={onSubmit}
          >
            Aplicar Filtro
          </Form.Button>
        </Form.Field>
        </div>
      </Form>
    );
  }
}

const mapstate = (state) => ({
  stores: {
    ...state.stores,
    data: StoresSelectors.options(state.stores.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators({ ...StoresActions }, dispatch);

export default connect(mapstate, mapActions)(Filters);
